<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <h1>
          {{ $t("detalleConsulta.titulo") }}
          <b v-if="solicitud">{{ solicitud.token }}</b>
          <span class="button_back">
            <Button
              @click.stop="goToListaSolicitudes()"
              :label="$t('common.buttons.verConsultas')"
              class="buttonStyle lightBlueBG float-right"
            />
          </span>
        </h1>
        <div class="p-grid">
          <div class="p-col-12">
            <Panel v-if="solicitud" :header="null">
              <template slot="header">
                <div class="p-grid">
                  <div class="p-col-6 paddingTop10Px">
                    <span class="title"
                      ><b
                        >{{ $t("detalleConsulta.ficha.titulo") }}:
                        {{ solicitud.token }}</b
                      ></span
                    >
                  </div>
                </div>
              </template>

              <div class="p-grid">
                <div class="p-col-6">
                  <p v-if="solicitud.fechaAlta">
                    <b>{{ $t("detalleConsulta.campos.fechaAlta") }}:</b>
                    {{ getFormattedDateShort(solicitud.fechaAlta) }}
                  </p>
                  <p v-if="solicitud.idLegalDeudor">
                    <b>{{ $t("detalleConsulta.campos.deudor") }}:</b>
                    {{ solicitud.idLegalDeudor }}
                  </p>
                  <p v-if="solicitud.clienteIdLegal">
                    <b>{{ $t("detalleConsulta.campos.cliente") }}:</b>
                    {{ solicitud.clienteIdLegal }}
                  </p>
                  <p v-if="solicitud.tipo">
                    <b>{{ $t("detalleConsulta.campos.tipo") }}:</b>
                    {{ solicitud.tipo }}
                  </p>
                  <p v-if="canBeDownloaded(solicitud.estado)">
                    <b>{{ $t("detalleConsulta.campos.ficheros") }}:</b>
                    <Button
                      :disabled="isSubmiting"
                      @click="
                        getListaDocumentosMinio(typeFileFM, solicitud.token)
                      "
                      :header="$t('misconsultas.header.descargar')"
                      class="
                        buttonStyle
                        lightBlueBG
                        p-button p-button-icon-only
                        paddingTopMinus5
                        hand
                      "
                      icon="pi pi-file-pdf"
                      style="margin-left: 0.25em"
                      iconPos="left"
                    />
                  </p>
                </div>
                <div class="p-col-6">
                  <p v-if="solicitud.origen">
                    <b>{{ $t("detalleConsulta.campos.origen") }}:</b>
                    {{ solicitud.origen }}
                  </p>
                  <p v-if="solicitud.estado">
                    <b>{{ $t("detalleConsulta.campos.estado") }}:</b>
                    {{ solicitud.estado }}
                  </p>
                  <p v-if="solicitud.fechaEstado">
                    <b>{{ $t("detalleConsulta.campos.fechaEstado") }}:</b>
                    {{ getFormattedDateShort(solicitud.fechaEstado) }}
                  </p>
                  <p v-if="solicitud.justificacion">
                    <b>{{ $t("detalleConsulta.campos.justificacion") }}</b
                    >: {{ solicitud.justificacion }}
                  </p>
                </div>
                <div v-if="!ocultar" class="p-col-12">
                  <DataTable
                    :value="deudas"
                    :lazy="true"
                    :paginator="true"
                    :rows="tamPaginaDeudas"
                    :totalRecords="totalRecordsDeudas"
                    class="p-datatable-responsive"
                    dataKey="token"
                    @page="onPage($event)"
                    :autoLayout="true"
                  >
                    <template #header>
                      <div class="table-header">
                        {{ $t("detalleConsulta.deuda.header") }}
                      </div>
                    </template>
                    <template #empty>
                      {{ $t("common.noResultados") }}
                    </template>

                    <Column
                      field="origenDeuda"
                      :header="$t('detalleConsulta.campos.deuda.origenDeuda')"
                      :sortable="true"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t("detalleConsulta.campos.deuda.origenDeuda")
                        }}</span>
                        {{ slotProps.data.literalOrigenDeudaDetalle.valor }}
                      </template>
                    </Column>
                    <Column
                      field="cnaeAcreedor"
                      :header="$t('detalleConsulta.campos.deuda.cnaeAcreedor')"
                      :sortable="true"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t("detalleConsulta.campos.deuda.cnaeAcreedor")
                        }}</span>
                        {{
                          slotProps.data.literalTipoCnae.clave +
                          " - " +
                          slotProps.data.literalTipoCnae.valor
                        }}
                      </template>
                    </Column>
                    <Column
                      field="fechaVencimientoPrimerImpago"
                      :header="
                        $t(
                          'detalleConsulta.campos.deuda.fechaVencimientoPrimerImpago'
                        )
                      "
                      :sortable="true"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t(
                            "detalleConsulta.campos.deuda.fechaVencimientoPrimerImpago"
                          )
                        }}</span>
                        {{
                          getFormattedDateShort(
                            slotProps.data.fechaVencimientoPrimerImpago
                          )
                        }}
                      </template>
                    </Column>
                    <Column
                      field="fechaVencimientoUltimoImpago"
                      :header="
                        $t(
                          'detalleConsulta.campos.deuda.fechaVencimientoUltimoImpago'
                        )
                      "
                      :sortable="true"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t(
                            "detalleConsulta.campos.deuda.fechaVencimientoUltimoImpago"
                          )
                        }}</span>
                        {{
                          getFormattedDateShort(
                            slotProps.data.fechaVencimientoUltimoImpago
                          )
                        }}
                      </template>
                    </Column>
                    <Column
                      field="fechaPublicacion"
                      :header="
                        $t('detalleConsulta.campos.deuda.fechaPublicacion')
                      "
                      :sortable="true"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t("detalleConsulta.campos.deuda.fechaPublicacion")
                        }}</span>
                        {{
                          getFormattedDateShort(slotProps.data.fechaPublicacion)
                        }}
                      </template>
                    </Column>

                    <Column
                      field="tokenExpediente"
                      :header="
                        $t('detalleConsulta.campos.deuda.tokenExpediente')
                      "
                      :sortable="true"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t("detalleConsulta.campos.deuda.tokenExpediente")
                        }}</span>
                        {{ slotProps.data.tokenExpediente }}
                      </template>
                    </Column>
                    <Column
                      field="importeImpagadoEnAlta"
                      :header="
                        $t('detalleConsulta.campos.deuda.importeImpagadoEnAlta')
                      "
                      :sortable="true"
                      bodyStyle="text-align: right"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t(
                            "detalleConsulta.campos.deuda.importeImpagadoEnAlta"
                          )
                        }}</span>
                        {{ slotProps.data.importeImpagadoEnAlta }}
                      </template>
                    </Column>
                    <Column
                      field="importePendiente"
                      :header="
                        $t('detalleConsulta.campos.deuda.importePendiente')
                      "
                      :sortable="true"
                      bodyStyle="text-align: right"
                    >
                      <template #body="slotProps">
                        <span class="p-column-title">{{
                          $t("detalleConsulta.campos.deuda.importePendiente")
                        }}</span>
                        {{ slotProps.data.importePendiente }}
                      </template>
                    </Column>
                  </DataTable>
                </div>
                <div v-if="!ocultar">
                  <p>
                    {{
                      $t("detalleConsulta.noDeuda", {
                        nif: solicitud.idLegalDeudor
                          ? solicitud.idLegalDeudor
                          : "",
                      })
                    }}
                  </p>
                </div>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_SOLICITUD_BY_TOKEN } from "@/graphQLQueries/ConsultasQueries.js";
import DatesMixin from "@/utils/dates";
import { ESTADO_SOLICITUD_FM, TIPOS_FICHEROS } from "@/resources/constants";
import DownloadsMixin from "@/utils/downloads";
import RoutesMixin from "@/utils/routes";
import { GET_LIST_FILES_BY_TYPE_CLAVE } from "@/graphQLQueries/DocStoreQueries";
import MessagesMixin from "@/utils/messages";

export default {
  name: "DetalleConsulta",
  mixins: [DatesMixin, DownloadsMixin, RoutesMixin, MessagesMixin],
  data() {
    return {
      tokenSolicitud: null,
      loading: true,
      statusAccepted: ESTADO_SOLICITUD_FM.SOLICITUD_ESTADO_ACEPTADA,
      typeFileFM: TIPOS_FICHEROS.FICH_MOROSIDAD_PDF,
      isSubmiting: false,
      deudas: [],
      tamPaginaDeudas: 10,
      numPaginaDeudas: 0,
      totalRecordsDeudas: 0,
      ocultar: true,
    };
  },
  created() {
    this.tokenSolicitud = this.$route.params.token;
    const deudas = this.$route.params.deudas;

    if (deudas) {
      this.deudas = this.fromJson(deudas);
      this.totalRecords = this.deudas.length;
    }
  },
  apollo: {
    solicitud: {
      query: GET_SOLICITUD_BY_TOKEN,
      variables() {
        return {
          token: this.tokenSolicitud,
        };
      },
      update(data) {
        this.loading = false;

        return data.getSolicitudByToken;
      },
    },
  },
  methods: {
    onPage(event) {
      this.numPaginaDeudas = event.page;
    },
    fromJson(json) {
      return JSON.parse(json);
    },
    goToListaSolicitudes() {
      this.goToListaConsultas();
    },
    getListaDocumentosMinio(type, clave) {
      this.isSubmiting = true;
      this.$apollo
        .query({
          query: GET_LIST_FILES_BY_TYPE_CLAVE,
          variables: {
            type: type,
            clave: clave,
          },
          fetchPolicy: "no-cache",
        })
        .then((data) => {
          let listaDocumentosMinio = data.data.getListFileByTypeAndClave;
          if (
            listaDocumentosMinio != null &&
            listaDocumentosMinio != undefined &&
            listaDocumentosMinio.length > 0
          ) {
            let documentoMinio = listaDocumentosMinio[0];
            this.download(
              documentoMinio.filename,
              documentoMinio.base64,
              document
            );
            this.setMessages(
              "success",
              this.$t("misconsultas.messages.success.descargaFichero"),
              3000
            );
          } else {
            this.setMessages(
              "info",
              this.$t("misconsultas.messages.info.descargaFichero"),
              3000
            );
          }
          this.disableSubmit();
        })
        .catch(() => {
          this.setMessages(
            "info",
            this.$t("misconsultas.messages.info.descargaFichero"),
            3000
          );
          this.disableSubmit();
        });
    },
    canBeDownloaded(statusRequest) {
      return statusRequest == this.statusAccepted;
    },
    disableSubmit() {
      let self = this;
      setTimeout(() => {
        self.isSubmiting = false;
      }, 3000);
    },
  },
};
</script>